import PropTypes from 'prop-types';
import React from 'react';
import {Button, Form, FormGroup, Input, InputGroup, InputGroupAddon, InputGroupText, Label} from 'reactstrap';
import logoImage from '../assets/img/logo/logo.png';
import Lock from 'react-icons/lib/fa/lock';
import Envelope from 'react-icons/lib/fa/envelope';


class AuthForm extends React.Component {
    constructor() {
        super();
        this.state = {};
    }

    get isLogin() {
        return this.props.authState === STATE_LOGIN;
    }

    get isSignup() {
        return this.props.authState === STATE_SIGNUP;
    }

    changeAuthState = authState => event => {
        event.preventDefault();

        this.props.onChangeAuthState(authState);
    };

    handleSubmit = event => {
        event.preventDefault();

        this.props.onSubmit(event, this.state);
    };

    renderButtonText() {
        const {buttonText} = this.props;

        if (!buttonText && this.isLogin) {
            return 'ACESSAR PAINEL';
        }

        if (!buttonText && this.isSignup) {
            return 'Signup';
        }

        return buttonText;
    }

    handleChange = (event) => {
        let obg = {};
        obg[event.target.name] = event.target.value;
        this.setState(obg);
    };

    render() {
        const {
            showLogo,
            authEmailLabel,
            authEmailInputProps,
            passwordLabel,
            passwordInputProps,
            confirmPasswordLabel,
            confirmPasswordInputProps,
            children,
            onLogoClick,
        } = this.props;
        return (
            <Form onSubmit={this.handleSubmit}>
                {showLogo && (
                    <div className="text-center pb-4">
                        <img
                            src={logoImage}
                            className="rounded"
                            style={{width: 150, height: 150, cursor: 'pointer'}}
                            alt="logo"
                            onClick={onLogoClick}
                        />
                    </div>
                )}
                <FormGroup>
                    {/*<Label for={authEmailLabel}>{authEmailLabel}</Label>*/}
                    <InputGroup>
                        <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                                <Envelope/>
                            </InputGroupText>
                        </InputGroupAddon>
                        <Input {...authEmailInputProps} onChange={this.handleChange}/>
                    </InputGroup>
                </FormGroup>
                <FormGroup>
                    {/*<Label for={passwordLabel}>{passwordLabel}</Label>*/}
                    <InputGroup>
                        <InputGroupAddon addonType="prepend">
                            <InputGroupText style={{fontSize: 20}}>
                                <Lock/>
                            </InputGroupText>
                        </InputGroupAddon>
                        <Input {...passwordInputProps} onChange={this.handleChange}/>
                    </InputGroup>
                </FormGroup>
                {this.isSignup && (
                    <FormGroup>
                        <Label for={confirmPasswordLabel}>{confirmPasswordLabel}</Label>
                        <Input {...confirmPasswordInputProps} />
                    </FormGroup>
                )}
                <Button
                    size="lg"
                    className="border-0 btn-login"
                    block>
                    {this.renderButtonText()}
                </Button>
                {children}
            </Form>
        );
    }
}

export const STATE_LOGIN = 'LOGIN';
export const STATE_SIGNUP = 'SIGNUP';

AuthForm.propTypes = {
    authState: PropTypes.oneOf([STATE_LOGIN, STATE_SIGNUP]).isRequired,
    showLogo: PropTypes.bool,
    authEmailLabel: PropTypes.string,
    authEmailInputProps: PropTypes.object,
    passwordLabel: PropTypes.string,
    passwordInputProps: PropTypes.object,
    confirmPasswordLabel: PropTypes.string,
    confirmPasswordInputProps: PropTypes.object,
    onLogoClick: PropTypes.func,
    onSubmit: PropTypes.func,
    onChangeAuthState: PropTypes.func,
};

AuthForm.defaultProps = {
    authState: 'LOGIN',
    showLogo: true,
    authEmailLabel: 'Email',
    authEmailInputProps: {
        name: 'email',
        type: 'email',
        placeholder: 'Digite aqui seu e-mail',
    },
    passwordLabel: 'Password',
    passwordInputProps: {
        name: 'password',
        type: 'password',
        placeholder: 'Digite aqui a sua Senha',
    },
    confirmPasswordLabel: 'Confirm Password',
    confirmPasswordInputProps: {
        type: 'password',
        placeholder: 'confirm your password',
    },
    onLogoClick: () => {
    },
};

export default AuthForm;



// WEBPACK FOOTER //
// ./src/components/AuthForm.js